// extracted by css-extract-rspack-plugin
export default {"avatarWrapper":"ProfileAvatar_avatarWrapper__uHNQU","settingsIcon":"ProfileAvatar_settingsIcon__XL0eZ"};